import { faArrowRightArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Loading from '../../../../../shared/components/Loading';
import { CircularProgress } from '@mui/material';
import moment from 'moment';
import { toast } from 'react-toastify';

const TicketsTable = ({
    filteredResults,
    currentPresupuesto,
    isLoading,
    setTicketToConfirm,
    handleState,
}) => {
    const handleCopyPhone = (phone) => {
        navigator.clipboard.writeText(phone);
        toast.success('Teléfono copiado!');
    };

    return (
        <table className="table">
            <thead>
                <tr>
                    <th className="text-center">Nº</th>
                    <th className="text-center">nombre</th>
                    <th className="text-center">telefono</th>
                    <th className="text-center">observaciones</th>
                    <th className="text-center">responsable</th>
                    <th className="text-center">fecha</th>
                    <th></th>
                </tr>
            </thead>

            <tbody>
                {filteredResults && filteredResults.length > 0 ? (
                    filteredResults?.map((ticket) => {
                        return (
                            <tr key={ticket.id}>
                                <td className="text-center">
                                    {ticket.id}
                                </td>
                                <td className="text-center">
                                    {ticket.entidad.nombre}
                                </td>
                                <td
                                    className="text-center"
                                    title="Clica para copiar el teléfono"
                                    style={{ cursor: 'pointer' }}
                                    onClick={() =>
                                        handleCopyPhone(ticket.entidad.telefono)
                                    }
                                >
                                    {ticket.entidad.telefono}
                                </td>
                                <td className="text-center" width="40%">
                                    {ticket.observaciones}
                                </td>
                                <td className="text-center">
                                    {ticket.crafted_by.username}
                                </td>
                                <td className="text-center">
                                    {moment(ticket.created_at).format(
                                        'DD-MM-YYYY'
                                    )}
                                </td>
                                {currentPresupuesto ? (
                                    <th className="text-center">
                                        <div>
                                            <button
                                                className="btn btn-primary"
                                                onClick={() =>
                                                    setTicketToConfirm(ticket)
                                                }
                                                disabled={
                                                    isLoading === ticket.id
                                                }
                                            >
                                                {isLoading === ticket.id ? (
                                                    <CircularProgress
                                                        color="inherit"
                                                        size={18}
                                                    />
                                                ) : (
                                                    'Asignar'
                                                )}
                                            </button>
                                        </div>
                                    </th>
                                ) : (
                                    <td className="text-center">
                                        <div
                                            className="d-flex flex-column align-items-center justify-content-center"
                                            style={{ cursor: 'pointer' }}
                                            title="Cambiar estado"
                                            onClick={() =>
                                                handleState(ticket)
                                            }
                                        >
                                            <FontAwesomeIcon icon={faArrowRightArrowLeft} style={{ color: '#215732' }} />
                                        </div>
                                    </td>
                                )}
                            </tr>
                        );
                    })
                ) : (
                    <>
                        {isLoading === true ? (
                            <tr>
                                <td colSpan={7} className="text-center">
                                    <Loading />
                                </td>
                            </tr>
                        ) : (
                            <tr>
                                <td colSpan={7} className="text-center">
                                    No hay tickets
                                </td>
                            </tr>
                        )}
                    </>
                )}
            </tbody>
        </table>
    );
};

export default TicketsTable;
